export default __webpack_public_path__ + "static/media/852hz-higher-consciousness.abc2c9ba.mp3";